var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('div',{staticClass:"hero__container"},[_c('div',{staticClass:"hero__text"},[_vm._t("default"),_c('button-explore')],2)]),_c('span',{attrs:{"id":"content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }